import styled from "@emotion/styled";
import { css } from '@emotion/react'
import { theme } from "../Utils/theme";

const btnVariant = {
    main : {
        normal : '#f95f53',
        hover : '#E0564B',
        active : '#C74C42',
        disabled : '#f5f5f5'
    },
    outline : {
        normal : '#ffffff',
        hover : '#fdcfcb',
        active : '#fcafa9',
        disabled : '#f5f5f5'
    },
    sub : {
        normal : '#ffddda',
        hover : '#ffc0bb',
        active : '#fb9f98',
        disabled : '#f5f5f5'
    },
    gray : {
        normal : '#f5f5f5',
        hover : '#f5f5f5',
        active : '#f5f5f5',
        disabled : '#ececec'
    }
}

const btnTextVariant = {
    main : '#ffffff',
    outline : '#f95f53',
    sub : '#f95f53',
    gray : '#3f3f3f'
}

export const Title = styled.h1`
    color : ${theme.color.main};
    @media screen and (max-width : 880px){
        font-size : 24px;
    }
    @media screen and (min-width : 801px){
        font-size : 36px;
    }
    @media screen and (min-width : 1300px){
        font-size : 48px;
    }
`

export const SubTitle = styled.h5`
    color : ${theme.color.title};
    @media screen and (max-width : 880px){
        font-size : 14px;
    }
    @media screen and (min-width : 801px){
        font-size : 24px;
    }
    @media screen and (min-width : 1300px){
        font-size : 14px;
    }
`

export const titleCss = css`
    color : ${theme.color.main};
    font-size : 18px
`

export const Button = styled.button`
    background-color : ${props => btnVariant[props.variant].normal};
    border-width : ${props => props.variant === 'outline' ? '1px' : '0'};
    border-style : solid;
    border-radius : 8px;
    color : ${props => btnTextVariant[props.variant]};
    padding: ${props => props.small ?  '8px 10px 8px 10px' : '16px 10px 16px 10px' };
    border-color : #f65f53;
    font-weight : 500;
    font-family : "Pretendard";
    line-height: 1.71;
    font-size : ${props => typeof props.fontSize === 'undefined' ? '14px' : props.fontSize+'px'};

    &:hover {
        background-color : ${props => btnVariant[props.variant].hover};
    }
    &:active {
        background-color : ${props => btnVariant[props.variant].active};
    }
    &:disabled {
        background-color : ${props => btnVariant[props.variant].disabled};
        border-color : ${props => btnVariant[props.variant].disabled};
        color : #9f9f9f;
    }
`

export const Input = styled.input`
    display: flex;
    padding : 12px 0 12px 24px;
    border-radius : 8px;
    border : solid 1px #ececec;
    background-color : white;

    font-size : 14px;
    font-weight : 500;
    line-height : 1.71;
    color : #3f3f3f;
    box-sizing : border-box;

    &:focus {
        outline : none;
        border-color : #f65f53;
    }
    &:disabled {
        color : #9f9f9f;
    }
`

export const Textarea = styled.textarea`
    display: flex;
    padding : 24px 0 24px 24px;
    border-radius : 8px;
    border : solid 1px #ececec;
    background-color : white;

    font-size : 14px;
    font-weight : 500;
    line-height : 1.71;
    color : #3f3f3f;
    box-sizing : border-box;

    &:focus {
        outline : none;
        border-color : #f65f53;
    }
`